import React from 'react';
import { classNames } from './classNames';

export type DropdownMenuProps = React.HTMLAttributes<HTMLUListElement>;

const DropdownMenu = React.forwardRef<HTMLUListElement, DropdownMenuProps>(({
  className,
  children,
  ...props
}, ref) => (
  <ul ref={ref} className={classNames('dropdown-menu', className)} {...props}>
    {children}
  </ul>
));

DropdownMenu.displayName = 'DropdownMenu';

export default DropdownMenu;
